import { useState } from 'react';
import { useMutation, useQuery } from '@tanstack/react-query';
import Button from '../ui/Button';
import Modal from '../ui/Modal';
import Select from '../ui/Select';
import { listExcelTemplates } from '../../api/excelTemplates';
import { saveBlobResponse } from '../../utils/download';
import { pushToast } from '../ui/toastBus';

// Pick an Excel template (Workflow → Excel Templates) and download the given requests with it.
// `onExport(ids, templateId)` returns the blob response from the page's export endpoint.
export default function ExcelDownloadModal({ open, onClose, ids, onExport }) {
  const [templateId, setTemplateId] = useState('');
  const templatesQuery = useQuery({ queryKey: ['excel-templates'], queryFn: listExcelTemplates, enabled: open });
  const templates = templatesQuery.data || [];

  const download = useMutation({
    mutationFn: () => onExport(ids, templateId),
    onSuccess: (response) => {
      saveBlobResponse(response, 'requests.xlsx');
      onClose();
    },
    onError: () => pushToast({ type: 'error', message: 'Could not download the Excel file.' }),
  });

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={`Download as Excel${ids.length > 1 ? ` (${ids.length} requests)` : ''}`}
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={() => download.mutate()} loading={download.isPending} disabled={!templateId}>
            Download
          </Button>
        </>
      }
    >
      <Select label="Template" value={templateId} onChange={(e) => setTemplateId(e.target.value)}>
        <option value="">Select a template…</option>
        {templates.map((t) => (
          <option key={t.id} value={t.id}>
            {t.name}
          </option>
        ))}
      </Select>
      {!templatesQuery.isLoading && templates.length === 0 && (
        <p className="mt-2 text-xs text-gray-500">No templates yet — create one under Workflow → Excel Templates.</p>
      )}
    </Modal>
  );
}
